module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('boxWrap', {
    attrs: {
      "name": _vm.name,
      "min": true
    }
  }, [_c('div', {
    staticClass: "table"
  }, [_c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "list-item list-item1"
  }, [_c('div', {
    staticClass: "item"
  }, [_vm._v("产品名称")]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_vm._v("码关联数量")]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_vm._v("扫码数量")])]), _vm._v(" "), (_vm.tableData.length > 0) ? _c('swiper', {
    ref: "mySwiper",
    staticClass: "swiper-wrap",
    attrs: {
      "options": _vm.swiperOption
    }
  }, [(_vm.tableData.length > 5) ? _vm._l((_vm.tableData), function(item) {
    return _c('swiper-slide', {
      staticClass: "list-item"
    }, [_c('div', {
      staticClass: "item"
    }, [_vm._v(_vm._s(item.productName))]), _vm._v(" "), _c('div', {
      staticClass: "item"
    }, [_vm._v(_vm._s(item.relationCount || 0))]), _vm._v(" "), _c('div', {
      staticClass: "item"
    }, [_vm._v(_vm._s(item.scanCount || 0))])])
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.tableData), function(item) {
    return _c('div', {
      staticClass: "list-item"
    }, [_c('div', {
      staticClass: "item"
    }, [_vm._v(_vm._s(item.productName))]), _vm._v(" "), _c('div', {
      staticClass: "item"
    }, [_vm._v(_vm._s(item.relationCount || 0))]), _vm._v(" "), _c('div', {
      staticClass: "item"
    }, [_vm._v(_vm._s(item.scanCount || 0))])])
  })], 2) : _vm._e()], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-b6fa512c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/runda/trace/components/table/index.vue
// module id = 2078
// module chunks = 2